module.exports = __webpack_public_path__ + "img/motorway_4x3.90945fa3.svg";